module.exports = __webpack_public_path__ + "img/head_img.5ef9bcd9.png";